import React, { Fragment } from 'react'
import { Heading, Paragraph, Label } from 'atoms/Texts'
import { LabelWithIcon, LabelWithStatus } from 'molecules/LabelEnhanced'
import { SidebarContainer, HeaderContainer, CloseBtnContainer, CloseBtn } from './styles'
import { withTheme } from 'styled-components'
import lo from 'lodash'
import moment from 'moment'

const icons = {
  ic_cal: require('App/assets/images/ic_cal_bk.png'),
  ic_pin: require('App/assets/images/ic_pin_bk.png'),
  ic_time: require('App/assets/images/ic_time_bk.png'),
  ic_user: require('App/assets/images/ic_user_bk.png')
}

const CollaborationSidebar = ({ theme, data, isClosing, onCloseIssue, reopen, pathToList, canReopen }) => {
  return (
    <SidebarContainer>
      {!lo.isEmpty(data) ?
        <Fragment>
          <HeaderContainer>
            <Heading size={'s'} color={theme.mocaOrange}>
              {data.title}
            </Heading>
            <Paragraph mb={'0'}>
              {data.description}
            </Paragraph>
          </HeaderContainer>
          <LabelWithIcon icon={icons.ic_pin} text={data.pit.name} />
          <LabelWithIcon icon={icons.ic_cal} text={moment(data.dateDeadline).format('dddd, MMMM D YYYY')} />
          <LabelWithIcon icon={icons.ic_time} text={moment(data.dateDeadline).format('h:mm A')} />
          <LabelWithIcon icon={icons.ic_user} text={data.user.displayName} />
          <LabelWithStatus text={'Severity'} value={data.severity} transparent={true} />
          <LabelWithStatus text={'Status'} value={data.isClosed} transparent={false} />
          <CloseBtnContainer>
            {canReopen &&
              <CloseBtn
                btnTxt={'Re-open Issue'}
                bg={theme.mocaRed}
                width={'120px'}
                height={'36px'}
                onClick={reopen}
              />
            }
            {(!data.isClosed && !data.isPartiallyClose) &&
              <CloseBtn
                btnTxt={isClosing ? 'Closing...' : 'Close Issue'}
                btnIcon={'clipboard-check'}
                width={'120px'}
                height={'36px'}
                disabled={isClosing}
                onClick={() => onCloseIssue()}
              />
            }
          </CloseBtnContainer>
        </Fragment> :
        <Fragment>
          <Label>Data is empty.</Label>
        </Fragment>
      }
    </SidebarContainer>
  )
}

export default withTheme(CollaborationSidebar)
